import store from '@/store';

export function getMapCenter() {
    if(!store.getters.mapBounds) return false;
    let center = {
        lat: ((store.getters.mapBounds._ne.lat - store.getters.mapBounds._sw.lat) / 2) + store.getters.mapBounds._sw.lat,
        lon: ((store.getters.mapBounds._ne.lng - store.getters.mapBounds._sw.lng) / 2) + store.getters.mapBounds._sw.lng,
    }
    return center;
}

export function toLatLngArray(coordinates) {
    if(coordinates.lat && coordinates.lng) {
        return [coordinates.lat, coordinates.lng]
    } else if(coordinates.length === 2) {
        return [...coordinates].reverse()
    }
    return [0, 0]
}